function getURLVar(key) {
  var value = [];

  var query = String(document.location).split('?');

  if (query[1]) {
    var part = query[1].split('&');

    for (i = 0; i < part.length; i++) {
      var data = part[i].split('=');

      if (data[0] && data[1]) {
        value[data[0]] = data[1];
      }
    }

    if (value[key]) {
      return value[key];
    } else {
      return '';
    }
  }
}
function isEmpty( el ){
  return !$.trim(el.html())
}
$(document).ajaxStop(function() {
  function isEmpty( el ){
    return !$.trim(el.html())
  }
  if (!isEmpty($('#product'))) {
    $('#product .option-container').addClass('has-option');
  }
});
$("#spicegems_cr_btn_no").click(function(){
    $(this).parents(".spicegems_cr_modal").remove()
    $(".modal-backdrop").remove();
    $("body").removeClass(".modal-open");
});
function divWidthMenu() {
  var width_br = $(".container-fix .block-right").outerWidth(true);
  var width_count = $(".container-fix > .container").width();
  var width_bl = $("#logo img").outerWidth(true);
  if ($(".hd1").length || $(".hd2").length) {
    $('.home1 .container-fix .`main-menu').outerWidth(width_count - width_bl - width_br-30);
  }
}
function customResponsive(){
  var window_w = parseInt($(window).width());

  $(".group1 #logo img").each(function() {
    if( this.complete ) {
      divWidthMenu.call( this );
    } else {
      $(this).one('load', divWidthMenu);
    }
  });

  var offsetMargin = 0-$('.wrapper').outerWidth(true)*2.6/100;
  if ( $(".hd2").length ) {
    $('.banner8').css('margin-left',offsetMargin);
    $('.banner8').css('margin-right',offsetMargin);
  }
}
$(window).resize(function() {
  customResponsive();
});
 //$('#input-sort').click(function(e) {
  // var selectheight = $(this).height();
   //var scrollPos = $(this).offset().top;
   //var selectoptioncount = $(this).find("option").length;
   //var totaloffset = $(selectoptioncount*selectheight+scrollPos);
   //var selectsize = $(selectoptioncount*selectheight);
   //e.preventDefault();
   // $('html, body').animate({
   ////   scrollTop: $($(e.target).attr("id","gf-products")).offset().top
   // }, 0);
   //console.log(totaloffset);
   //console.log(selectoptioncount*selectheight);
  //});
$(document).ready(function() {
  //$( ".main_menu li .sub_menu" ).wrapAll("<div class='subnavmain'></div>");
  $( ".main_menu li .subnavmain" ).before("<span class='dropdown'></span>");
  $('.dropdown').click(function() {
      $(this).next().toggleClass("showdropdown");
  });
  
  $( ".main_menu li .subnavmain").each(function(e){
    if ($(this).find('.mega-menu-title').length) {
    } else {
      $(this).find('.sub_menu').addClass('linewise');
    }
  });
  var className = $('header').attr('class');
  if ($(".header3").length) {
    $('.contentforlayout').addClass('container1-page');
  }

  // vertical thumbs on product page
  

  // product video
  $('.popup-youtube, .popup-vimeo, .popup-gmaps').magnificPopup({
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

  // color / option swatch js snippet
  // $('.swatch :radio').change(function(e) {
  //   if ($(this).prop('disabled')) {
  //     e.stopPropagation();
  //   } else {
  //     var optionIndex = $(this).closest('.swatch').attr('data-option-index');
  //     var optionValue = $(this).val();
  //     let variants = this.getAttribute('data-product');
  //     const parsedVariants = JSON.parse(variants);
  //    // Array to store matched variants
  //     const matchedVariants = [];

  //     // Loop through all parsedVariants
  //     parsedVariants.forEach(variant => {
  //         // Check if any option matches the selected size value
  //         if (variant.options.some(opt => opt === this.value)) {
  //             matchedVariants.push(variant);
  //         }
  //     });

  //     // Now loop through all matched variants
  //     matchedVariants.forEach(variant => {
  //         // Get the size selector container (DOM element)
  //         const sizeSelector = $(this).closest('form').find('#sizelist')[0];

  //         if (!sizeSelector) {
  //             console.warn('Size selector not found');
  //             return;
  //         }
  //         // Get all .size-product inputs inside the container
  //         const sizeInputs = sizeSelector.querySelectorAll('.size-product');
  //         // Loop through each size input
  //         sizeInputs.forEach((input, index) => {
  //             console.log(`Size input ${index}:`, input.value);

  //             // Optional: Check if this input matches the current variant
  //             if (variant.options.includes(input.value)) {
  //               const parent = input.parentElement;       // Parent wrapper div
  //               const label = parent.querySelector('.size-lbl');  // Label inside parent
              
  //               if (variant && variant.available) {
  //                 input.disabled = false;
  //                 input.classList.remove('unavailable');
  //                 parent.classList.remove('soldout');    // soldout class on parent
  //                 if (label) {
  //                   const outSpan = label.querySelector('.out-size');
  //                   if (outSpan) outSpan.remove();       // remove "Out of Stock" span
  //                 }
  //               } else {
  //                 input.disabled = true;
  //                 input.classList.add('unavailable');
  //                 parent.classList.add('soldout');       // soldout class on parent
  //                 if (label) {
  //                   if (!label.querySelector('.out-size')) {
  //                     const outSizeSpan = document.createElement('span');
  //                     outSizeSpan.className = 'out-size';
  //                     outSizeSpan.textContent = ' Out of Stock ';
  //                     label.appendChild(outSizeSpan);    // add span inside label
  //                   }
  //                 }
  //               }
  //             }
              
              
  //         });
  //     });


  //     // Sync Shopify's option selectors so the correct variant ID is selected
  //     $(this)
  //       .closest('form')
  //       .find('.single-option-selector')
  //       .eq(optionIndex)
  //       .val(optionValue)
  //       .trigger('change');

  //     // If there is no size selector on this product (color‑only product),
  //     // automatically enable the sticky "Add to cart" button once a color is chosen.
  //     if ($('#form_buy input.size-product').length === 0) {
  //       $('#button-cart-duplicate')
  //         .addClass('active')
  //         .html('Add to Cart');
  //     }
  //   }
  // });
// Function to update size options and Add to Cart button
let pageLoad = true; // global flag

function updateSizeOptions(selectedRadio) {
    if ($(selectedRadio).prop('disabled')) return;

    const optionIndex = parseInt($(selectedRadio).closest('.swatch').attr('data-option-index'));
    const optionValue = $(selectedRadio).val();

    const variants = JSON.parse(selectedRadio.getAttribute('data-product'));

    // Match variants by option index (correct way)
    const matchedVariants = variants?.filter(v => v.options[optionIndex] === optionValue);

    const formElement = $(selectedRadio).closest('form');
    const sizeSelector = formElement.find('#sizelist')[0];

    if (sizeSelector) {
        const sizeInputs = sizeSelector.querySelectorAll('.size-product');

        sizeInputs.forEach(input => {
            const inputValue = input.value;

            const correspondingVariant = matchedVariants?.find(v => v.options.includes(inputValue));

            const parent = input.parentElement;
            const label = parent.querySelector('.size-lbl');

            if (correspondingVariant) {
                if (correspondingVariant.available) {
                    input.disabled = false;
                    input.classList.remove('unavailable');
                    parent.classList.remove('soldout');

                    const outSpan = label?.querySelector('.out-size');
                    if (outSpan) outSpan.remove();
                } else {
                    input.disabled = true;
                    input.classList.add('unavailable');
                    parent.classList.add('soldout');

                    if (label && !label.querySelector('.out-size')) {
                        const outSizeSpan = document.createElement('span');
                        outSizeSpan.className = 'out-size';
                        outSizeSpan.textContent = ' Out of Stock ';
                        label.appendChild(outSizeSpan);
                    }
                }
            }
        });
    }

    // Update Shopify hidden selectors
    const formSelector = formElement.find('.single-option-selector').eq(optionIndex);
    formSelector.val(optionValue);

    if (!pageLoad) formSelector.trigger('change');

    // Update Add to Cart button
    const sizeInputs = formElement.find('input.size-product');
    let anyAvailable = sizeInputs.length === 0;

    if (!anyAvailable) {
        sizeInputs.each(function() {
            if (!$(this).prop('disabled')) anyAvailable = true;
        });
    }

    const addToCartBtn = $('#button-cart-duplicate');
    if (anyAvailable) {
        addToCartBtn.addClass('active').text('Add to Cart');
    } else {
        addToCartBtn.removeClass('active').text('Sold Out');
    }
}

// iOS FIX — Safari requires input+click+change
$('.swatch :radio').on('change input click', function() {
    if (!$(this).prop('disabled')) {
        pageLoad = false;
        updateSizeOptions(this);
        pageLoad = true;
    }
});

// On page load
$(document).ready(function() {
    $('.swatch :radio:checked').each(function() {
        updateSizeOptions(this);
    });
});



  
  
  $('.size-lbl').click(function(e) {
    if ($(this).parent('.swatch-element').find('.size-product').prop('disabled')) {
      e.stopPropagation();
    } else {
      $(this).parent('.swatch-element').find('.size-product').prop("checked", true).trigger("click");
      
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).parent('.swatch-element').find('.size-product').val();
      console.log(optionValue);
      $(this)
      .closest('form')
      .find('.single-option-selector')
      .eq(optionIndex)
      .val(optionValue)
      .trigger('change');
    }
    
  });

//   $(".accessories-modal-submit").unbind();
//   $('.accessories-modal-submit').on('click', function(e) {
//   	e.preventDefault();
//     console.log('here');
//     return;
//   });
  // product page add to cart
  //$('#button-cart').on('click', function(e) {
 
  
  $('#button-cart').on('click', function(e) {
    e.preventDefault();
    	var product_id = $('#form_buy #productSelect').val();
		var quantity = $('#form_buy input.num-product').val();
        var productsize = $('#form_buy input.size-product:checked').val();

//     datax={
//       "id"       : $("#productSelect").children("option:selected").val(),
//       "quantity" : $("#Quantity").val()
//     };
    if ($('#form_buy input.size-product').length == 0) {
      productsize = 1;
    }
    if(typeof (productsize) !==  'undefined')
    {
      
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      //data: $('#form_buy input[type=\'text\'], #form_buy select'),
//       data:datax,
      data: 'id=' + product_id + '&quantity=' + (typeof (quantity) != 'undefined' ? quantity : 1),
      dataType: 'json',
      beforeSend: function() {
        $('#button-cart').button('loading');
      },
    
      complete: function() {
        $('#button-cart').button('reset');
      },
      success: function(json) {
           
        console.log(json);
        $('.cart-popup-wrapper').removeClass('cart-popup-wrapper--hidden');
        $('.cart-popup-wrapper').addClass('menu-open');
        addTocartPopup(json,quantity);
        $('.alert, .text-danger').remove();
        $('.form-group').removeClass('has-error');

        if (json['error']) {
          if (json['error']['option']) {
            for (i in json['error']['option']) {
              var element = $('#input-option' + i.replace('_', '-'));
              if (element.parent().hasClass('input-group')) {
                element.parent().after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              } else {
                element.after('<div class="text-danger">' + json['error']['option'][i] + '</div>');
              }
            }
          }

          if (json['error']['recurring']) {
            $('select[name=\'recurring_id\']').after('<div class="text-danger">' + json['error']['recurring'] + '</div>');
          }

          // Highlight any found errors
          $('.text-danger').parent().addClass('has-error');
        }

//         swal("Added to Cart confirmation !", "");
      
        $.getJSON('/cart.js', function(cart) {
//          console.log(cart);
          $('.cart-total').html(cart.item_count);
          if(cart.item_count < 1) {
            $('.cart-total').addClass("hide");
          } else {
             $('.cart-total').removeClass("hide");
          }
          $(".cart-total").attr("data-item", cart.item_count);
          Currency?.convertAll(shopCurrency, Currency?.cookie.read());
        });
		$('.swal-button--confirm').on('click', function(e) {
//           location.reload();
        });
        $('html, body').animate({ scrollTop: 0 }, 'slow');

        $('#cart').load('/ #cart #subcart');
        $('#cart-mobile').load('/ #cart-mobile #subcart-mobile');
        //        $('#cart > .top-cart-contain ul').load('/ #cart > .top-cart-contain ul li');
        //  $('#cart > ul').load('/ #cart > ul li');
        
      },
      error: function(xhr, ajaxOptions, thrownError) {
       
        


var data=xhr.responseText;
var jsonResponse = JSON.parse(data);
 var desc = jsonResponse["description"];
//        alert(desc);
        swal("Sorry!","You can't add more item in to the cart.", "error")
      }
    });
    
    }
    else
    {
       swal("Sorry!","Please Select the size.", "error")
        $('#button-cart').button('reset');
    }
  });
  
  //add product details to cart 
  
  function addTocartPopup(item,qty) {
    var sizedImageUrl = getSizedImageUrl(item.featured_image.url, '200x');
    var image = document.createElement('img');
    image.src = sizedImageUrl;
    image.alt = item.featured_image.alt;
    image.classList.add("cart-popup-item__image");

    $('.cart-popup-item__image-wrapper').html(image);
    $('.cart-popup-item__image-wrapper').removeClass('hide');
    $('.cart-popup-item__title').text(item.product_title);
    $('.cart-popup-item__quantity span[data-cart-popup-quantity]').text(qty);

    //     if(!multiple_var){
    if(item.options_with_values[0].value != 'Default Title') {
      $('.cart-popup-item__description .product-details')
      .html('<li class="product-details__item">'+ item.options_with_values[0].name +': '+ item.options_with_values[0].value +'</li>');
    }
    //     }

    $.getJSON('/cart.js').then(
      function (cart) {
        $("#CartCount").removeClass("hide");
        $('a.cart-popup__cta-link span[data-cart-popup-cart-quantity]').text(cart.item_count);
        $("#CartCount").children("[data-cart-count]").text(cart.item_count);
      }
    );
  }

  function closePopupRemoveDetails() {
    $('.cart-popup-wrapper').addClass('cart-popup-wrapper--hidden');
    $('.cart-popup-wrapper').removeClass('menu-open');
    $('.cart-popup-item__image').remove();
    $('.cart-popup-item__title').text('');
    $('.cart-popup-item__image-wrapper').addClass('hide');
    $('.product-details__item').remove();
    $('.cart-popup-item__quantity span[data-cart-popup-quantity]').text('');
   }

  $('.cart-popup__close').click(function(){
    closePopupRemoveDetails();
  });
  
  $('.cart-popup__dismiss-button').click(function(){
    closePopupRemoveDetails();
  });

  $(window).click(function(event){
    if (!$(event.target).closest(".cart-popup-wrapper").length) {
      if ($('.cart-popup-wrapper').hasClass('menu-open')) {
        closePopupRemoveDetails();
      }
    } 
  });
  
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return removeProtocol(src);
    }

    var match = src.match(
      /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i
    );

    if (match !== null) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return removeProtocol(prefix[0] + '_' + size + suffix);
    }

    return null;
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  // move breadcrumbs
  $("header").after('<div class="breadcrumbs"><div class="container"></div></div>');
  var breadcrumb = $('ul.breadcrumb');
  var breadcrumbs_container = $('.breadcrumbs .container');
  breadcrumb.appendTo(breadcrumbs_container);
  $('.breadcrumb').before($('.category-name'));
  $('.breadcrumb').before($('.block-2 .heading-title'));

  var sticky_menu = $('#sticky-menu').attr('data-sticky');
  if (sticky_menu==1){
    var headerSpaceH = $('header').outerHeight(true);
    $('header').after('<div class="headerSpace unvisible" style="height:'+headerSpaceH+'px;"></div>');
  }
  // Scroll
  var currentP = 0;
  var stickyOffset = 0;

  stickyOffset = $('header').offset().top;
  stickyOffset += $('header').outerHeight();
  stickyOffset += 30;
  $(window).scroll(function(){
    var headerH = $('header').height();
    var scrollP = $(window).scrollTop();

    if($(window).width() > 1024){
      if(scrollP != currentP){
        //Sticky header
        if (sticky_menu==1){
          if(scrollP >= stickyOffset){
            $('.group1 .container-fix').addClass('fix-header');
            $('.group2 .main-menu').addClass('fix-header');
            $('.headerSpace').removeClass('unvisible');
          } else {
            $('.group1 .container-fix').removeClass('fix-header');
            $('.group2 .main-menu').removeClass('fix-header');
            $('.headerSpace').addClass('unvisible');
          }
        }
        currentP = $(window).scrollTop();
      }
    }
  });

  $('.container-fix').hover(function(){
    $(this).addClass("fix-header-act");
  },function(){
    $(this).removeClass("fix-header-act");
  });

  customResponsive();

  if (!isEmpty($('#product'))) {
    $('#product .option-container').addClass('has-option');
  }
  if (!isEmpty($('#product2'))) {
    $('#product2 .option-container').addClass('has-option');
  }

  // move toolbar category
  $('.layer-category').prepend($('.custom-category .toolbar'));

  // Highlight any found errors
  $('.text-danger').each(function() {
    var element = $(this).parent().parent();

    if (element.hasClass('form-group')) {
      element.addClass('has-error');
    }
  });

  /* Search */
  $('#search input[name=\'q\']').parent().find('button').on('click', function() {
    var url = '/search';

    var value = $('#search input[name=\'q\']').val();
    if(value == "Search all products..." || value ==""){
      jQuery('#search input[name=\'q\']').focus();
      return false;
    }else {
      url += '?type=product&q=' + encodeURIComponent(value);
    }

    location = url;
  });

  $('#search input[name=\'q\']').on('keydown', function(e) {
    if (e.keyCode == 13) {
      $('#search input[name=\'q\']').parent().find('button').trigger('click');
    }
  });

  // Menu
  $('#menu .dropdown-menu').each(function() {
    var menu = $('#menu').offset();
    var dropdown = $(this).parent().offset();

    var i = (dropdown.left + $(this).outerWidth()) - (menu.left + $('#menu').outerWidth());

    if (i > 0) {
      $(this).css('margin-left', '-' + (i + 10) + 'px');
    }
  });

  // Product List
  $('#list-view').click(function() {
    $('.custom-products').removeClass('custom-products-row');
    $(this).addClass('selected');
    $('#grid-view').removeClass('selected');
    $('#content .product-grid > .clearfix').remove();

    //$('#content .product-layout').attr('class', 'product-layout product-list col-xs-12');
    $('#content .product-grid').attr('class', 'product-layout product-list col-xs-12');
    $('#content .product-list .caption').addClass('col-xs-8');
    $('#content .product-list .image').addClass('col-xs-4');


    localStorage.setItem('display', 'list');
  });

  // Product Grid
  $('#grid-view').click(function() {
    $('.custom-products').addClass('custom-products-row');
    $(this).addClass('selected');
    $('#list-view').removeClass('selected');
    // What a shame bootstrap does not take into account dynamically loaded columns
    cols = $('#column-right, #column-left').length;

    if (cols == 2) {
      $('#content .product-layout').attr('class', 'product-layout product-grid col-md-6 col-sm-6 col-xs-6 two-items');
    } else if (cols == 1) {
      $('#content .product-layout').attr('class', 'product-layout product-grid col-md-4 col-sm-6 col-xs-6 three-items');
    } else {
      $('#content .product-layout').attr('class', 'product-layout product-grid col-md-3 col-sm-6 col-xs-6 four-items');
    }
    $('#content .product-grid .caption').removeClass('col-xs-8');
    $('#content .product-grid .image').removeClass('col-xs-4');


    localStorage.setItem('display', 'grid');
  });

  if (localStorage.getItem('display') == 'list') {

    $('#list-view').trigger('click');
  } else {
    $('#grid-view').trigger('click');
  }

  // Checkout
  $(document).on('keydown', '#collapse-checkout-option input[name=\'email\'], #collapse-checkout-option input[name=\'password\']', function(e) {
    if (e.keyCode == 13) {
      $('#collapse-checkout-option #button-login').trigger('click');
    }
  });

  // tooltips on hover
  $('[data-toggle=\'tooltip\']').tooltip({container: 'body'});

  // Makes tooltips work on ajax generated content
  $(document).ajaxStop(function() {
    $('[data-toggle=\'tooltip\']').tooltip({container: 'body'});
  });
  
  
});

// Cart add remove functions
var cart = {
  'add': function(product_id, product_title, quantity) {
    $.ajax({
      url: '/cart/add.js',
      type: 'post',
      data: 'id=' + product_id + '&quantity=' + (typeof(quantity) != 'undefined' ? quantity : 1),
      dataType: 'json',
      beforeSend: function() {
        var btn = $(this);
        $('.btn-cart > .button').button('loading');
      },
      complete: function() {
        $('.btn-cart > .button').button('reset');
      },
      success: function(json) {
        $('.alert, .text-danger').remove();

        if (json['redirect']) {
          location = json['redirect'];
        }
        swal(product_title, "is added to cart !", "success");
        // toastr.success('Congratulation! Your item has been added.')

        $.getJSON('/cart.js', function(cart) {
          setTimeout(function () {
            $('.cart-total').html(cart.item_count);
            if(cart.item_count < 1) {
              $('.cart-total').addClass("hide");
            } else {
              $('.cart-total').removeClass("hide");
            }
            $(".cart-total").attr("data-item", cart.item_count);
          }, 100);
          //Currency.convertAll(shopCurrency, Currency.cookie.read());
        });
        
      },
      error: function(xhr, ajaxOptions, thrownError) {
        alert(xhr.responseText);
      }
    });
  },
  'remove': function(key) {
    $.ajax({
      url: '/cart/update.js',
      type: 'post',
      data: 'updates['+key+']=0',
      dataType: 'json',
      beforeSend: function() {
        $('#cart').removeClass('show-header-dropdown');
      },
      success: function(json) {
        $('#cart > button').button('reset');
        setTimeout(function () {
          $('.cart-total').html(json['item_count']);
          if(json['item_count'] < 1) {
            $('.cart-total').addClass("hide");
          } else {
             $('.cart-total').removeClass("hide");
          }
          $(".cart-total").attr("data-item", json['item_count']);
        }, 100);
        // Currency.convertAll(shopCurrency, Currency.cookie.read());

        if (getURLVar('route') == '/cart' || getURLVar('route') == '/checkout') {
          //location = '/cart';
          location.reload();
        } else {
          $('#cart').load('/ #cart #subcart');
          
          $('#cart-mobile').load('/ #cart-mobile #subcart-mobile');
        }
      },
      error: function(xhr, ajaxOptions, thrownError) {
        alert(xhr.responseText);
      }
    });
  }
}
$('#cart').load('/ #cart #subcart');

 $('#cart-mobile').load('/ #cart-mobile #subcart-mobile');
/* Agree to Terms */
$(document).delegate('.agree', 'click', function(e) {
  e.preventDefault();

  $('#modal-agree').remove();

  var element = this;

  $.ajax({
    url: $(element).attr('href'),
    type: 'get',
    dataType: 'html',
    success: function(data) {
      html  = '<div id="modal-agree" class="modal">';
      html += '  <div class="modal-dialog">';
      html += '    <div class="modal-content">';
      html += '      <div class="modal-header">';
      html += '        <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>';
      html += '        <h4 class="modal-title">' + $(element).text() + '</h4>';
      html += '      </div>';
      html += '      <div class="modal-body">' + data + '</div>';
      html += '    </div>';
      html += '  </div>';
      html += '</div>';

      $('body').append(html);

      $('#modal-agree').modal('show');
    }
  });
});
$('.search-head').click(function() {
	$(".search-drop").toggleClass("show-header-dropdown");
});

// Autocomplete */
(function($) {
  $.fn.autocomplete = function(option) {
    return this.each(function() {
      this.timer = null;
      this.items = new Array();

      $.extend(this, option);

      $(this).attr('autocomplete', 'off');

      // Focus
      $(this).on('focus', function() {
        this.request();
      });

      // Blur
      $(this).on('blur', function() {
        setTimeout(function(object) {
          object.hide();
        }, 200, this);
      });

      // Keydown
      $(this).on('keydown', function(event) {
        switch(event.keyCode) {
          case 27: // escape
            this.hide();
            break;
          default:
            this.request();
            break;
        }
      });

 


      
      // Click
      this.click = function(event) {
        event.preventDefault();

        value = $(event.target).parent().attr('data-value');

        if (value && this.items[value]) {
          this.select(this.items[value]);
        }
      }

      // Show
      this.show = function() {
        var pos = $(this).position();

        $(this).siblings('ul.dropdown-menu').css({
          top: pos.top + $(this).outerHeight(),
          left: pos.left
        });

        $(this).siblings('ul.dropdown-menu').show();
      }

      // Hide
      this.hide = function() {
        $(this).siblings('ul.dropdown-menu').hide();
      }

      // Request
      this.request = function() {
        clearTimeout(this.timer);

        this.timer = setTimeout(function(object) {
          object.source($(object).val(), $.proxy(object.response, object));
        }, 200, this);
      }

      // Response
      this.response = function(json) {
        html = '';

        if (json.length) {
          for (i = 0; i < json.length; i++) {
            this.items[json[i]['value']] = json[i];
          }

          for (i = 0; i < json.length; i++) {
            if (!json[i]['category']) {
              html += '<li data-value="' + json[i]['value'] + '"><a href="#">' + json[i]['label'] + '</a></li>';
            }
          }

          // Get all the ones with a categories
          var category = new Array();

          for (i = 0; i < json.length; i++) {
            if (json[i]['category']) {
              if (!category[json[i]['category']]) {
                category[json[i]['category']] = new Array();
                category[json[i]['category']]['name'] = json[i]['category'];
                category[json[i]['category']]['item'] = new Array();
              }

              category[json[i]['category']]['item'].push(json[i]);
            }
          }

          for (i in category) {
            html += '<li class="dropdown-header">' + category[i]['name'] + '</li>';

            for (j = 0; j < category[i]['item'].length; j++) {
              html += '<li data-value="' + category[i]['item'][j]['value'] + '"><a href="#">&nbsp;&nbsp;&nbsp;' + category[i]['item'][j]['label'] + '</a></li>';
            }
          }
        }

        if (html) {
          this.show();
        } else {
          this.hide();
        }

        $(this).siblings('ul.dropdown-menu').html(html);
      }

      $(this).after('<ul class="dropdown-menu"></ul>');
      $(this).siblings('ul.dropdown-menu').delegate('a', 'click', $.proxy(this.click, this));

    });
  }
})(window.jQuery);

      $(document).ready(function() {
	      var display_time; //= $("#newsletter-popup-conatiner").attr("data-display_time");
        
        display_time = 10;
        
        display_time = parseInt(display_time) * 1000 ;
         console.log(display_time);
    // Hide the div
    $("#newsletter-popup-conatiner").hide();

    // Show the div in 5s
    $("#newsletter-popup-conatiner").delay(display_time).fadeIn(500);
        
//         setTimeout(function() {
//             $('#newsletter-popup-conatiner').fadeOut(500);
//         }, display_time); 

        
        $("#msg-popup-conatiner").hide();
        $('#msg-popup-trigger').click(function() {
        	$("#msg-popup-conatiner").fadeIn(500);
        });
        
        $("#msg-popup-conatiner .hide-popup").click(function() {
            $("#msg-popup-conatiner").fadeOut(500);
        });
        
        $(document).click(function(event) {
        if ($(event.target).is("#msg-popup-conatiner")) {
          $("#msg-popup-conatiner").fadeOut(500);
        }
      });
});


$("#sizelist").on("click", "label", function(event){
  if( $(this).parent("li").hasClass( "available" ))
  {
	 radio_value = $(this).prev("input[type='radio']").val();

    $("#size-btn").html(radio_value); 
    $('#button-cart-duplicate').html('Add to cart');
    jQuery('#button-cart-duplicate').addClass('active');
}
})


var ua = navigator.userAgent.toLowerCase(); 
if (ua.indexOf('safari') != -1) { 
  if (ua.indexOf('chrome') > -1) {
   
  } else {
   
   jQuery("#sizelist li.swatch-element").click(function(){
     
     jQuery("#sizelist").removeClass("show");
     jQuery("#size-btn").text(jQuery(this).attr("data-value"));
    jQuery('#button-cart-duplicate').html('Add to cart');
     jQuery('#button-cart-duplicate').addClass('active');
  });
  }
}
jQuery("#button-cart-duplicate").click(function(){
  if (jQuery(this).hasClass('active')) {
    $('#button-cart').trigger('click');
  } else {
    $('html, body').animate({
        scrollTop: $("#size-btn").offset().top - 300
    }, 100);
  }
});
// jQuery(".wrap-table-shopping-cart button.remove").on("click", function(){
//  jQuery(this).parents("tr").remove();
//   location.reload();
// })

$( ".reload-remove-cart-page" ).click(function() {
  
  	setTimeout(
            function() {
                  location.reload();
            },
            500);
});

$('.custom-dropdown').click(function() {
      console.log('test')
        $('.dropdown-content').toggleClass('show');
    });

$(document).click(function(event) {
  if (!$(event.target).closest('.search-head').length) {
    if ($(".header-dropdown").hasClass("show-header-dropdown")) {
      $(".header-dropdown").removeClass("show-header-dropdown");
    }
  }
  
  if (!$(event.target).closest('.custom-dropdown').length) {
    if ($(".dropdown-content").hasClass("show")) {
      $(".dropdown-content").removeClass("show");
    }
  }
});  

$(document).ready(function() {
  var x1 = $(".cart-total").attr("data-item");
  console.log(x1);
  if(x1 == 0) {
    $(".cart-total").addClass("hide");
  } else {
  	$(".cart-total").removeClass("hide");
  }
});

$(document).ready(function() {
  var j = 0;
  $('.blog-article .related-products .related-products-lists').each(function(){
    var productlength = $('.blog-article .related-products .related-products-lists').length;
    j++; 
    if(j>4) {
     jQuery(this).remove();
    } 
    
    if(productlength < 4){
      $(this).parent().addClass("centerProduct");
      $(this).parent().parent().children(".title-related-products").addClass("text-center");
    }
  });
});
